import { graphql } from "@/data-access/graphql";

const BriefingSlotBindingFragment = graphql(`
  fragment BriefingSlotBindingFragment on BriefingSlotBinding @_unmask {
    __typename
    slotId
    prompt
    title
    position
  }
`);

export const BriefingDefinitionFragment = graphql(
  `
    fragment BriefingDefinitionFragment on BriefingDefinition @_unmask {
      __typename
      id
      name
      description
      overallPrompt
      lookbackDays
      recipients
      requiresApproval
      canEdit
      status
      createdAt
      updatedAt
      templateUpdatedAt
      schedule {
        sendOn
        sendAt
        timezone
      }
      template {
        id
      }
      imageAssets {
        slotId
        assetId
        url
      }
      slotBindings {
        ...BriefingSlotBindingFragment
      }
    }
  `,
  [BriefingSlotBindingFragment],
);
